import { createApp } from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import { ENV } from '@/config/env'

var headers = {
  "Content-Type": "application/json",
  "Authorization": `Token ${ENV.VUE_APP_AUTH_TOKEN}`
};

var headers_file = {
  "Content-Type": "multipart/form-data",
  "Authorization": `Token ${ENV.VUE_APP_AUTH_TOKEN_FILE}`
};

var baseURL = ENV.VUE_APP_BASE_URL;
var url_from_app_user = ENV.VUE_APP_URL_FROM_APP_USER;
var url_dashboard = ENV.VUE_APP_URL_FROM_DASHBOARD;

var http = axios.create({
  baseURL: baseURL,
  headers: headers,
});

var http_file = axios.create({
  baseURL: baseURL,
  headers: headers_file,
});

export { http, http_file, axios, url_from_app_user, url_dashboard };
